import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { useDateOfBirthInput } from "@/hooks/user-info-form/useDateOfBirthInput";

export function DateOfBirthInput() {
  const { user, errors, t, handleChange, handleBlur } =
    useDateOfBirthInput();

  return (
    <div className="space-y-2">
      <Label className="text-base">{t("userInfoForm.dateOfBirth")}</Label>
      <Input
        id="dateOfBirth"
        value={user?.dateOfBirth || ""}
        onChange={(e) => handleChange(e.target.value)}
        onBlur={(e) => handleBlur(e.target.value)}
        placeholder={t("userInfoForm.dateOfBirthPlaceholder")}
        className={errors.dateOfBirth ? "border-red-500" : ""}
      />
      {errors.dateOfBirth && (
        <p className="text-sm text-red-500 mt-1">{errors.dateOfBirth}</p>
      )}
    </div>
  );
}
